// Pulls the companySlug out of a user's catalogUrl if it matches the pattern udacity.com/org/companySlug/catalog

export function extractCompanySlug(catalogUrl: string | null | undefined): string | null {
  if (!catalogUrl) {
    return null;
  }

  const companySlugMatch = catalogUrl.match(/udacity\.com\/org\/([^\/]+)\/catalog/);
  // EMC catalog will eventually be deprecated, this may be removed in the future
  const emcCompanySlugMatch = catalogUrl.match(/udacity\.com\/c\/([^\/]+)\/catalog/);
  const companySlug = companySlugMatch?.[1] ?? emcCompanySlugMatch?.[1];

  return companySlug ?? null;
}
